<template>
  <Styles>
    <section id="store_container">
      <b-modal
          :on-cancel="closeEditModal"
          v-model="editModal"
          :width="850"
          scroll="keep"
      >
        <div class="modal-card" style="width: auto" id="editModal">
          <header class="modal-card-head header-modal">
            <p class="modal-card-title" style="color: white; margin: 0">
              <i class="mr-2 mdi mdi-magnify"></i>Consultar conceptos
            </p>
            <button type="button" class="delete" @click="closeEditModal()"/>
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column">
                <b-table
                    :data="conceptsEditList"
                    :selected.sync="selectedEdit"
                    focusable
                >
                  <b-table-column field="Code" label="Código" v-slot="props">
                    {{ props.row.code }}
                  </b-table-column>
                  <b-table-column field="name" label="Nombre" v-slot="props">
                    {{ props.row.title }}
                  </b-table-column>
                  <b-table-column
                      field="type"
                      label="Tipo Concepto"
                      v-slot="props"
                  >
                    {{ getConceptTypeLabel(props.row.initials) }}
                  </b-table-column>
                  <template #empty>
                    <div class="has-text-centered">Sin registros</div>
                  </template>
                </b-table>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button type="is-info" label="Aceptar" @click="fillData()"/>
            <b-button
                type="is-danger"
                label="Cancelar"
                @click="closeEditModal()"
            />
          </footer>
        </div>
      </b-modal>
      <fieldset class="fieldset">
        <legend>Detalles</legend>
        <div class="details-concept">
          <div class="columns">
            <div class="column">
              <b-field label="Empresa *">
                <Treeselect
                    :options="companies"
                    :disable-branch-nodes="true"
                    :show-count="true"
                    v-model="company"
                    name="company"
                    v-validate="'required'"
                    placeholder="Seleccione una empresa"
                />
              </b-field>
              <span class="show-error">{{ errors.first("company") }}</span>
            </div>
            <div class="column">
              <b-field label="Nombre *">
                <b-input
                    placeholder="Nombre"
                    type="text"
                    name="name"
                    v-model="name"
                    v-validate="'required'"
                    icon-right="magnify"
                    icon-right-clickable
                    @icon-right-click="openEditModal()"
                >
                </b-input>
              </b-field>
              <span class="show-error">{{ errors.first("name") }}</span>
            </div>
            <div class="column">
              <b-field label="Tipo de concepto *">
                <b-select
                    placeholder="Seleccione el tipo de concepto"
                    expanded
                    v-model="conceptType"
                    name="conceptType"
                    v-validate="'required'">
                  <option
                      v-for="option in conceptTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.description }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("conceptType") }}</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4">
              <b-field label="Tipo de valor *">
                <b-select
                    placeholder="Seleccione un tipo de valor..."
                    expanded
                    v-model="valueType"
                    name="valueType"
                    v-validate="'required'"
                >
                  <option
                      v-for="option in valueTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("valueType") }}</span>
            </div>
            <div class="column is-4">
              <b-field class="mt-checkbox">
                <b-checkbox
                    name="isPercent"
                    v-model="isPercent"
                    true-value="Y"
                    false-value="N"
                >
                  Es porcentaje
                </b-checkbox>
              </b-field>
            </div>
          </div>
        </div>
        <fieldset class="fieldset mt-5" v-if="conceptList.length > 0">
          <legend>Conceptos relacionados</legend>
          <div class="columns">
            <div class="column is-4">
              <b-field label="Conceptos">
                <b-select
                    placeholder="Seleccionar"
                    expanded
                    v-model="concept"
                    name="concept"
                >
                  <option
                      v-for="option in conceptList"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code"
                  >
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-4">
              <vs-button
                  color="primary"
                  class="pl-5 pr-5 mt-button"
                  type="filled"
                  add="add"
                  @click="addRelation()"
              >
                Agregar
              </vs-button>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-table
                  :data="getAssociatedList()"
                  :selected.sync="selected"
                  focusable
                  :paginated="true"
                  :per-page="5"
                  :bordered="true"
                  :current-page.sync="currentPage"
              >
                <b-table-column field="Code" label="Código" v-slot="props">
                  {{ props.row.code }}
                </b-table-column>
                <b-table-column field="name" label="Nombre" v-slot="props">
                  {{ props.row.title }}
                </b-table-column>
                <b-table-column
                    field="type"
                    label="Tipo Concepto"
                    v-slot="props"
                >
                  {{ getConceptTypeLabel(props.row.initials) }}
                </b-table-column>
                <b-table-column field="actions" label="Acciones" v-slot="props">
                  <b-field>
                    <b-button
                        type="is-info"
                        title="Editar"
                        @click="editConcept(props.row)"
                        style="margin-right: 3px"
                        icon-right="pencil"
                    />
                    <b-button
                        type="is-danger"
                        title="Eliminar"
                        @click="deleteConcept(props.row)"
                        icon-right="delete"
                    />
                  </b-field>
                </b-table-column>
                <template #bottom-left></template>
                <template #empty>
                  <div class="has-text-centered">Sin registros</div>
                </template>
              </b-table>
            </div>
          </div>
        </fieldset>
      </fieldset>
      <div class="buttons button-group">
        <vs-button
            color="primary"
            type="filled"
            icon="save"
            @click="save()"
            class="pl-4 pr-4"
        >
          Guardar
        </vs-button>
        <vs-button
            color="danger"
            type="filled"
            icon="delete"
            @click="deleteActual()"
            class="pl-4 pr-4 ml-3"
            v-if="actualCode"
        >
          Eliminar
        </vs-button>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </section>
  </Styles>
</template>

<script>
import {ROUTES} from "../../global/api_routes";
import Treeselect from "@riophae/vue-treeselect";
import Styles from "./styles";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {confirmation} from "../../global/utils";
import {configToast, TOAST_TYPES} from "../../global/toast";

export default {
  name: "Concepts",
  components: {Treeselect, Styles},
  data: () => ({
    id: null,
    selectedEdit: null,
    actualCode: null,
    company: null,
    name: null,
    type: null,
    conceptType: null,
    conceptsEditList: [],
    conceptList: [],
    associatedConcepts: [],
    selected: null,
    isLoading: false,
    currentPage: 1,
    concept: null,
    companies: [],
    editModal: false,
    valueType: null,
    isPercent: "N",
    types: [
      {title: "Si", code: "Y"},
      {title: "No", code: "N"},
    ],
    valueTypes: [
      {title: "Suma", code: "S"},
      {title: "Informativo", code: "I"},
    ],
    conceptTypes: [],
  }),
  mounted() {
    this.getCompanies();
    this.getConceptTypes();
  },
  watch: {
    company: function () {
      if (!this.company) {
        return;
      }
      this.getConceptList();
    },
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#subscription_container");
      return instance.open(message, type);
    },
    openEditModal() {
      if (!this.company) {
        this.toast("Debes selecionar una empresa", TOAST_TYPES.ERROR);
        return;
      }
      this.editModal = true;
      if (this.conceptsEditList.length > 0) {
        return;
      }
      this.isLoading = true;
      this.getConceptsEditList();
    },
    deleteActualConcept() {
      this.isLoading = true;
      this.$http
          .delete(ROUTES.DASHBOARD.CONCEPTS.DELETE, {
            params: {
              code: this.actualCode,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.toast("Se ha eliminado el registro", TOAST_TYPES.SUCCESS);
              this.cleanForm();
              return;
            }
            this.toast("No se pudo eliminar el registro", TOAST_TYPES.ERROR);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    deleteActual() {
      confirmation(this, "¿Deseas eliminar este concepto?").then((result) => {
        if (!result) {
          return;
        }
        this.deleteActualConcept();
      });
    },
    closeEditModal() {
      this.editModal = false;
    },
    getAssociatedList() {
      return this.associatedConcepts.filter((item) => !item.deleted);
    },
    getConceptsEditList() {
      this.$http
          .get(ROUTES.DASHBOARD.CONCEPTS.LIST_BY_COMPANY, {
            params: {
              companyId: this.company,
            }
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.conceptsEditList = data.info;
              return;
            }
            this.toast(data.message, TOAST_TYPES.ERROR);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getRelatedConcepts() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.CONCEPTS.LIST_RELATEDS, {
            params: {
              conceptCode: this.actualCode,
            }
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.associatedConcepts = data.info;
              return;
            }
            // this.toast(data.message, TOAST_TYPES.ERROR);
          })
          .catch((error) => {
            this.toast(
                "Error desconocido al consultar conceptos relacionados",
                TOAST_TYPES.ERROR
            );
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    addRelation() {
      if (!this.concept) {
        this.toast("Seleccione un concepto", TOAST_TYPES.ERROR);
        return;
      }
      const list = [...this.associatedConcepts];
      const conceptSelected = this.conceptList.find(
          (item) => item.code == this.concept
      );
      list.push(conceptSelected);
      this.associatedConcepts = list;
      console.log(this.associatedConcepts);
    },
    getConceptTypeLabel(conceptCode) {
      const concept = this.conceptTypes.find(
          (item) => item.code == conceptCode
      );
      if (!concept) {
        return "---";
      }
      return concept.description;
    },
    cleanForm() {
      this.name = null;
      this.valueType = null;
      this.conceptType = null;
      this.company = null;
      this.associatedConcepts = [];
      this.numeral = null;
      this.actualCode = null;
      this.isPercent = "N";
    },
    getRelatedsList() {
      return this.associatedConcepts.map((item) => ({
        related: {code: item.code},
        status: "D",
      }));
    },
    fillData() {
      const {code, title, numeral, initials, valueType, percent} =
          this.selectedEdit;
      this.actualCode = code;
      this.name = title;
      this.conceptType = initials;
      this.valueType = valueType;
      this.numeral = numeral;
      this.editModal = false;
      this.isPercent = percent;
      this.getRelatedConcepts();
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        this.isLoading = true;
        this.$http
            .post(ROUTES.DASHBOARD.CONCEPTS.SAVE, {
              code: this.actualCode,
              numeral: this.numeral ? this.numeral : 1,
              title: this.name,
              initials: this.conceptType,
              valueType: this.valueType,
              company: {code: this.company},
              relatedsList: this.getRelatedsList(),
              isPercent: this.isPercent,
            })
            .then(({data}) => {
              if (data.code > 0) {
                this.toast(
                    this.actualCode
                        ? "Se ha actualizado el registro"
                        : "Se ha registrado el registro",
                    TOAST_TYPES.SUCCESS
                );
                this.$validator.reset();
                this.getConceptList();
                this.cleanForm();
                return;
              }
              this.toast(data.message, TOAST_TYPES.ERROR);
              this.isLoading = false;
            })
            .catch((error) => {
              this.isLoading = false;
              this.toast(
                  "Se ha producido un error desconocido",
                  TOAST_TYPES.ERROR
              );
            });
      });
    },
    editConcept(concept) {
      window.open("/view/concepts?code=" + concept.code);
    },
    deleteConcept(concept) {
      confirmation(this, "¿Desea eliminar realmente esta relación?").then(
          (result) => {
            if (!result) {
              return;
            }
            const list = this.associatedConcepts.map((item) => ({
              ...item,
              deleted: item.code == concept.code,
            }));
            this.associatedConcepts = list;
          }
      );
    },
    getConceptList() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.CONCEPTS.LIST_BY_COMPANY, {
            params: {
              companyId: this.company,
            }
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.conceptList = data.info;
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getCompanies() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.GET_COMPANIES_TREE)
          .then(({data}) => {
            if (data.code > 0) {
              this.companies = data.info;
              this.processData(this.companies);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getConceptTypes() {
      this.$http.get(ROUTES.DASHBOARD.CONCEPTS.GET_TYPES).then(({data}) => {
        if (data.code > 0) {
          this.conceptTypes = data.info;
        }
      });
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let companie = companies[index];
        companie.label = companie.name;
        companie.id = companie.code;
        if (companie.children) {
          this.processData(companie.children);
        }
      }
    },
  },
};
</script>
